import { inject, Injectable } from '@angular/core';

import { BRAND } from '@tellent/types';

import { AnalyticsBase } from '@recruitee/analytics';

@Injectable({ providedIn: 'root' })
export class TellentAnalytics extends AnalyticsBase {
  public readonly brand = inject(BRAND);
  public readonly requireViewContext = false;

  public namespace: string;

  public track(event: string, data?: any): void {
    super.track(event, {
      ...data,
      app_context: this.brand,
      product_context: 'tellent',
    });
  }
}
